import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HeartPulse, ChevronDown, LayoutGrid, Check } from 'lucide-react';

// Selector de verticales del ecosistema Punto Cero System.
const VERTICALS = [
  { key: 'medicina', label: 'Punto Cero Salud', desc: 'Profesionales de salud y clínicas', to: '/system/medicina', icon: HeartPulse, color: '#14b8a6' },
];

export default function VerticalSwitcher({ current = 'medicina', accent = '#14b8a6' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="Cambiar de vertical"
        data-testid="vertical-switcher"
        className="flex items-center gap-2 px-3 py-2 rounded-xl bg-white/5 border border-white/15 text-white/80 hover:text-white hover:border-white/30 transition-all text-sm font-semibold"
      >
        <LayoutGrid className="w-4 h-4" style={{ color: accent }} />
        <span className="hidden sm:inline">System</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-64 rounded-2xl border border-white/15 bg-[#0f172a]/95 backdrop-blur-xl shadow-2xl p-2 z-[60]">
          <div className="px-3 py-2 text-[10px] font-bold uppercase tracking-[0.25em] text-white/40">Punto Cero System</div>
          {VERTICALS.map((v) => {
            const Icon = v.icon;
            const active = v.key === current;
            return (
              <Link
                key={v.key}
                to={v.to}
                onClick={() => setOpen(false)}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-xl transition-all ${active ? 'bg-white/10' : 'hover:bg-white/5'}`}
              >
                <div className="w-9 h-9 rounded-xl flex items-center justify-center border flex-shrink-0" style={{ background: `${v.color}1f`, borderColor: `${v.color}55` }}>
                  <Icon className="w-5 h-5" style={{ color: v.color }} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-white text-sm font-semibold leading-tight">{v.label}</div>
                  <div className="text-white/50 text-xs">{v.desc}</div>
                </div>
                {active && <Check className="w-4 h-4" style={{ color: v.color }} />}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
